import { TFilial } from '@/providers/Branch';
import { createContext, ReactElement } from 'react';

interface ContextBranchProps {
    filial: TFilial | null
    isLoading: boolean
}

export const ContextBranch = createContext<ContextBranchProps>({
    filial: null,
    isLoading: false
})
